<!-- Container-fluid starts -->
<div class="container-fluid mt-2" [class.distance-view]="distanceView">
  <div class="distance-toggle-wrap">
    <button
      type="button"
      class="distance-toggle-btn"
      [class.active]="distanceView"
      (click)="toggleDistanceView()">
      {{ distanceView ? 'Distance View: ON' : 'Distance View: OFF' }}
    </button>
  </div>
  <div class="row" style="height: 100%; min-height: 100vh; overflow: hidden;">
    <!-- <pre>{{selectedPatient | json}}</pre> -->

    <p-sidebar [(visible)]="scheduledLaterQueue" position="right" [modal]="true" dismissible="true" data-hotkey="patient-search"
      styleClass="scheduled-later-sidebar"
      [style]="{width:'40vw'}">
      <p-tabView>
        <p-tabPanel header="Scheduled Later Queue">
          <div class="d-flex flex-column h-100 patient-section scheduled-later-panel">

            <div class="flex-grow-1 overflow-auto p-2 w-100 schedule-later-shell">
              <div class="schedule-later-controls">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search name / patient no / contact"
                  [(ngModel)]="scheduledQueueSearchTerm"
                  (ngModelChange)="onScheduledQueueFilterChange()" />

                <select
                  class="form-select form-select-sm"
                  [(ngModel)]="scheduledQueueModeFilter"
                  (ngModelChange)="onScheduledQueueFilterChange()">
                  <option value="ALL">All Modes</option>
                  <option value="OPD">OPD</option>
                  <option value="COURIER">Courier</option>
                  <option value="NRI">NRI</option>
                </select>
              </div>

              <div class="schedule-later-segments">
                <button
                  type="button"
                  class="schedule-segment-btn"
                  [class.active]="scheduledQueueUrgencyFilter === 'all'"
                  (click)="setScheduledQueueUrgencyFilter('all')">
                  All ({{ scheduledQueueCounts.all }})
                </button>
                <button
                  type="button"
                  class="schedule-segment-btn"
                  [class.active]="scheduledQueueUrgencyFilter === 'overdue'"
                  (click)="setScheduledQueueUrgencyFilter('overdue')">
                  Overdue ({{ scheduledQueueCounts.overdue }})
                </button>
                <button
                  type="button"
                  class="schedule-segment-btn"
                  [class.active]="scheduledQueueUrgencyFilter === 'today'"
                  (click)="setScheduledQueueUrgencyFilter('today')">
                  Today ({{ scheduledQueueCounts.today }})
                </button>
                <button
                  type="button"
                  class="schedule-segment-btn"
                  [class.active]="scheduledQueueUrgencyFilter === 'tomorrow'"
                  (click)="setScheduledQueueUrgencyFilter('tomorrow')">
                  Tomorrow ({{ scheduledQueueCounts.tomorrow }})
                </button>
                <button
                  type="button"
                  class="schedule-segment-btn"
                  [class.active]="scheduledQueueUrgencyFilter === 'upcoming'"
                  (click)="setScheduledQueueUrgencyFilter('upcoming')">
                  Upcoming ({{ scheduledQueueCounts.upcoming }})
                </button>
              </div>

              <ng-container *ngIf="scheduledQueueGroups.length > 0; else noScheduledLaterQueue">
                <div *ngFor="let group of scheduledQueueGroups; trackBy: trackByScheduledGroup" class="schedule-group">
                  <div class="schedule-group-title">{{ group.label }} ({{ group.items.length }})</div>

                  <button
                    *ngFor="let item of group.items; trackBy: trackByScheduledItem"
                    type="button"
                    class="schedule-card"
                    [ngClass]="getScheduledQueueBadgeClass(item)"
                    [disabled]="isSelectingPatient"
                    (click)="selectFromNormalQueue(item)">
                    <div class="schedule-card-row">
                      <div class="schedule-patient">{{ item.patient_name || 'Unknown' }}</div>
                      <span
                        class="courier-badge mode-badge"
                        [ngClass]="getModeBadgeClass(item.is_courier)"
                        [title]="getModeTitle(item.is_courier)">
                        {{ getModeInitial(item.is_courier) }}
                      </span>
                    </div>

                    <div class="schedule-card-row meta">
                      <span>#{{ item.patient_number || '-' }}</span>
                      <span>{{ item.collection_date || '-' }}</span>
                      <span>{{ item.primary_contact || '-' }}</span>
                    </div>

                    <div class="schedule-card-row footer">
                      <span class="days-label">Days Left: {{ item.days_remaining }}</span>
                      <i class="pi pi-arrow-down"></i>
                    </div>
                  </button>
                </div>
              </ng-container>

              <ng-template #noScheduledLaterQueue>
                <div class="schedule-empty-state">
                  No scheduled later patients found.
                </div>
              </ng-template>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </p-sidebar>

    <button
      pButton
      type="button"
      icon="pi pi-calendar"
      class="queue-open-fab"
      *ngIf="!scheduledLaterQueue"
      (click)="openscheduleLaterQueueSidebar()"
      pTooltip="Open Scheduled Later Queue"
      aria-label="Scheduled Queue">
    </button>

    <!-- Left Sidebar -->
    <div class="col-md-3 border-end p-0 d-flex flex-column">
      <!-- Tabs for Queue and Search -->
      <div class="flex-grow-1 overflow-auto p-2 w-100">
        <p-tabView [(activeIndex)]="patientIndex" id="leftTabView" data-hotkey="patient-search">
          <!-- Queue Tab -->
          <p-tabPanel header="Queue">
            <div class="queue-toolbar">
              <button
                type="button"
                class="queue-refresh-btn"
                [disabled]="isQueueRefreshing"
                (click)="refreshQueue()"
                title="Refresh queue">
                <i class="pi pi-refresh" [class.pi-spin]="isQueueRefreshing"></i>
                {{ isQueueRefreshing ? 'Refreshing...' : 'Refresh Queue' }}
              </button>
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: '100vh' }" styleClass="modern-queue-scroll">
              
              <!-- Now Serving Section -->
              <div class="modern-queue-section" *ngIf="nowServingPatient">
                <div class="section-title text-success">
                  <i class="pi pi-play me-2"></i>Now Serving
                </div>
                <div class="modern-queue-list">
                  <button
                    tabindex="0"
                    class="list-group-item list-group-item-action modern-queue-card active-serving"
                    (click)="selectFromNormalQueue(nowServingPatient)"
                  >
                    <div class="card-left-border border-green"></div>
                    <div class="card-content">
                      <div class="card-row-1">
                        <span class="queue-number">#{{ nowServingPatient.index + 1 }}</span>
                        <span class="patient-name">{{ nowServingPatient.name | uppercase }}</span>
                      </div>
                      <div class="card-row-2 text-muted">
                        <span class="visit-type">{{ getAppointmentTypeLabel(nowServingPatient.appointment_type) }}</span>
                        <span *ngIf="nowServingPatient.gender" class="dot-separator">•</span>
                        <span *ngIf="nowServingPatient.gender" class="metadata-label">
                          {{ nowServingPatient.gender | titlecase }}
                          <ng-container *ngIf="nowServingPatient.age">{{ nowServingPatient.age }}y</ng-container>
                        </span>
                        <span class="dot-separator">•</span>
                        <span class="wait-time text-success fw-bold">In Pharmacy</span>
                      </div>
                      <div class="card-row-3 text-muted mt-1">
                        <span
                          class="draft-indicator"
                          pTooltip="In Pharmacy"
                          tooltipPosition="top"
                        >
                          <i class="pi pi-play-circle text-success" style="font-size: 12px"></i>
                        </span>
                        <span class="dot-separator">•</span>
                        <span class="appt-time">
                          <i class="pi pi-clock me-1" style="font-size: 10px"></i>{{ nowServingPatient.time }}
                        </span>
                        <span class="dot-separator">•</span>
                        <span class="mode-label">
                          <i class="pi pi-tag me-1" style="font-size: 10px"></i>{{ getModeTitle(nowServingPatient.is_courier) }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Up Next Section -->
              <div class="modern-queue-section" [class.mt-3]="nowServingPatient">
                <div class="section-title text-muted">
                  <i class="pi pi-list me-2"></i>Up Next
                </div>
                <div class="modern-queue-list">
                  <ng-container *ngFor="let item of queue; let i = index">
                    <button
                      *ngIf="i !== nowServingIndex"
                      tabindex="0"
                      class="list-group-item list-group-item-action modern-queue-card"
                      [disabled]="isSelectingPatient"
                      [class.queue-next-target]="isNextPatient(i)"
                      [ngClass]="[
                        getModernStatusColorClass(item),
                        isNextPatient(i) ? 'next-patient-row' : '',
                      ]"
                      (click)="selectFromNormalQueue(item)"
                    >
                      <div class="card-left-border" [ngClass]="getModernStatusColorClass(item)"></div>
                      <div class="card-content">
                        <div class="card-row-1">
                          <span class="queue-number">#{{ i + 1 }}</span>
                          <span class="patient-name">{{ item.name | uppercase }}</span>
                          <span *ngIf="isNextPatient(i)" class="next-chip ms-auto" title="Next patient in queue">NEXT</span>
                        </div>

                        <div class="card-row-2 text-muted">
                          <span class="visit-type">{{ getAppointmentTypeLabel(item.appointment_type) }}</span>
                          <span *ngIf="item.gender" class="dot-separator">•</span>
                          <span *ngIf="item.gender" class="metadata-label">
                            {{ item.gender | titlecase }}
                            <ng-container *ngIf="item.age">{{ item.age }}y</ng-container>
                          </span>
                          <span class="dot-separator">•</span>
                          <span
                            class="wait-time"
                            [ngClass]="getWaitTimeColorClass(getWaitTimeLabel(item.raw_time))"
                          >
                            {{ getWaitTimeLabel(item.raw_time) }}
                          </span>
                        </div>

                        <div class="card-row-3 text-muted mt-1">
                          <span
                            class="lifecycle-label text-xs fw-semibold"
                          >
                            {{ getQueueLifecycleLabel(item) }}
                          </span>
                          <span class="dot-separator ms-2">•</span>
                          <span class="appt-time">
                            <i class="pi pi-clock me-1" style="font-size: 10px"></i>{{ item.time }}
                          </span>
                          <span class="dot-separator">•</span>
                          <span class="mode-label">
                            <i class="pi pi-tag me-1" style="font-size: 10px"></i>{{ getModeTitle(item.is_courier) }}
                          </span>
                        </div>
                      </div>
                    </button>
                  </ng-container>
                </div>
              </div>
            </p-scrollPanel>
          </p-tabPanel>

          <!-- Search Tab -->
          <p-tabPanel header="Search">
            <div class="mb-2 w-100">
              <input type="date" name="date" id="date" class="form-control form-control-sm" [(ngModel)]="selectedDate" (ngModelChange)="onDateChange()">
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: '100vh' }">
              <div class="list-group list-group-flush">
                <button *ngFor="let item of dateWiseQueue"
                  class="list-group-item list-group-item-action queue-item-card"
                  [disabled]="isSelectingPatient"
                  [ngClass]="getColorClass(item.status)" (click)="selectFromDateWiseQueue(item)">
                  <div class="queue-item-main">
                    <div class="queue-item-name">{{ item.name }}</div>
                    <div class="queue-item-badges">
                      <span *ngIf="item.status === 'scheduled'" class="courier-badge status-badge status-scheduled" title="Scheduled">S</span>
                      <span *ngIf="(item.status === 'assistant_doctor') || (item.status === 'assistant_doctor_done')" class="courier-badge status-badge status-assistant-doctor" title="Assistant Doctor">AD</span>
                      <span *ngIf="item.status === 'doctor'" class="courier-badge status-badge status-doctor" title="Doctor">D</span>
                      <span *ngIf="item.status === 'medicine'" class="courier-badge status-badge status-pharmacy" title="Pharmacy">P</span>
                      <span *ngIf="(item.status === 'reception') || (item.status === 'receptionist')" class="courier-badge status-badge status-reception" title="Reception">R</span>
                      <span
                        class="courier-badge mode-badge"
                        [ngClass]="getModeBadgeClass(item.is_courier)"
                        [title]="getModeTitle(item.is_courier)">
                        {{ getModeInitial(item.is_courier) }}
                      </span>
                    </div>
                  </div>
                  <div class="queue-item-sub">
                    <span class="queue-item-time">{{ item.time }}</span>
                  </div>
                </button>
              </div>
            </p-scrollPanel>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>

    <div class="col-md-9 p-2">
      <p-tabView [(activeIndex)]="activeIndex">
        <p-tabPanel header="Dispense Medicine">

          <div class="row g-2 mb-2 small-head">
            
            <div class="col-md-2">
              <label>Patient No</label>
              <input type="text" class="form-control form-control-sm" [readonly]="true"
                    [(ngModel)]="patient.patient_number">
            </div>

            <!-- <div class="col-md-3">
              <label>Full Name</label>
              <input type="text" class="form-control form-control-sm" readonly
                    [(ngModel)]="patient.full_name">
            </div> -->

            <div class="col-md-2">
              <label>First Name</label>
              <input type="text" class="form-control form-control-sm" readonly
                    [(ngModel)]="patient.first_name">
            </div>

            <div class="col-md-2">
              <label>Middle Name</label>
              <input type="text" class="form-control form-control-sm" readonly
                    [(ngModel)]="patient.middle_name">
            </div>

            <div class="col-md-2">
              <label>Last Name</label>
              <input type="text" class="form-control form-control-sm" readonly
                    [(ngModel)]="patient.last_name">
            </div>

            <div class="col-md-2">
              <label>Follow Up Date</label>
              <input type="date" class="form-control form-control-sm"
                    [(ngModel)]="prescription.follow_up_date">
            </div>

            <div class="col-md-2 courier">
              <span
                class="input-group-text rounded-pill text-white fw-bold mode-pill"
                style="height: 32px"
                [ngClass]="getModeBadgeClass(prescription.is_courier)"
                [title]="getModeTitle(prescription.is_courier)">
                {{ getModeInitial(prescription.is_courier) }}
              </span>
            </div>

            <div class="col-md-12" *ngIf="prescription.special_instructions">
              <label>Special Instructions</label>
              <input type="text" class="form-control form-control-sm"
                    [(ngModel)]="prescription.special_instructions" readonly>
              <!-- <textarea class="form-control form-control-sm"
                    [(ngModel)]="prescription.special_instructions" readonly></textarea> -->
            </div>

          </div>

          <hr class="my-2">

          <div *ngFor="let pres of prescription.prescriptions; let i = index"
              class="p-2 mb-2 border rounded compact-card">

            <div class="d-flex align-items-center gap-2 mb-2 header-line">
              <span class="rx-label">Rx {{ i + 1 }}</span>

              <input type="text"
                    class="form-control form-control-sm"
                    placeholder="Title"
                    [(ngModel)]="pres.title"
                    readonly>

              <input type="text"
                    class="form-control form-control-sm"
                    placeholder="Duration"
                    [(ngModel)]="pres.duration"
                    readonly>
            </div>

            <div *ngFor="let med of pres.medicines"
                class="med-row mb-1 d-flex gap-2">

              <div class="form-control form-control-sm med-name-input med-code-display" aria-readonly="true">
                <!-- <ng-container *ngIf="getMedicineCodeParts(med?.tags) as codePartsList">
                  <ng-container *ngIf="codePartsList.length; else noMedicineCodes">
                    <ng-container *ngFor="let codeParts of codePartsList; let last = last">
                      <span [class.med-code-highlight]="codeParts.hasHighlight">{{ codeParts.prefix }}{{ codeParts.suffix }}</span><span *ngIf="!last">, </span>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #noMedicineCodes>-</ng-template> -->

                <ng-container *ngIf="med.codeParts?.length; else noMedicineCodes">
                  <ng-container *ngFor="let codeParts of med.codeParts; let last = last">
                    <span [class.med-code-highlight]="codeParts.hasHighlight">
                      {{ codeParts.prefix }}{{ codeParts.suffix }}
                    </span><span *ngIf="!last">, </span>
                  </ng-container>
                </ng-container>

                <ng-template #noMedicineCodes>-</ng-template>

              </div>

              <input type="text"
                    class="form-control form-control-sm small-input"
                    [(ngModel)]="med.drams"
                    placeholder="Dose"
                    readonly>

              <input type="text"
                    class="form-control form-control-sm medium-input"
                    [(ngModel)]="med.ballers"
                    placeholder="Schedule"
                    readonly>
            </div>
          </div>

          <div class="d-flex justify-content-start mt-2" *ngIf="role !== 'assistant_doctor' && role !== 'reception' && selectedPatientSource === 'normal'">
            <button (click)="changeStatus(prescription)" class="btn btn-success">Save</button>
          </div>

        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
